import { ReadyState } from 'react-use-websocket';
import { WEBSOCKET_TIMEOUT_MINUTES } from 'app/utils/hooks/constants';
import useInterval from 'use-interval';

export const useKeepWebSocketConnectionLive = ({
  lastMessageTimestamp,
  sendJsonMessage,
  readyState,
  reconnect,
}: {
  lastMessageTimestamp: number;
  sendJsonMessage: (json: object) => void;
  readyState: ReadyState;
  reconnect: () => void;
}) => {
  const getWsActionTime = (minutesOffset: number) =>
    lastMessageTimestamp +
    60 * 1000 * (WEBSOCKET_TIMEOUT_MINUTES + minutesOffset);

  const pingTime = getWsActionTime(-1);
  const reconnectTime = getWsActionTime(1);

  const ping = () => {
    const currentTime = new Date().getTime();
    if (reconnectTime <= currentTime) {
      reconnect();
    } else if (pingTime <= currentTime) {
      sendJsonMessage({ type: 'Ping' });
    }
  };

  useInterval(ping, readyState === ReadyState.OPEN ? 1000 * 60 : null, false);
  useInterval(
    reconnect,
    readyState === ReadyState.CLOSED ? 1000 * 10 : null,
    false
  );
};
